import { render } from "./Courses.vue?vue&type=template&id=5f1ab3ce&scoped=true&ts=true"
import script from "./Courses.vue?vue&type=script&lang=ts"
export * from "./Courses.vue?vue&type=script&lang=ts"

import "./Courses.vue?vue&type=style&index=0&id=5f1ab3ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1ab3ce"],['__file',"src/components/dashbaord/Courses.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f1ab3ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f1ab3ce', __exports__)) {
    api.reload('5f1ab3ce', __exports__)
  }
  
  module.hot.accept("./Courses.vue?vue&type=template&id=5f1ab3ce&scoped=true&ts=true", () => {
    api.rerender('5f1ab3ce', render)
  })

}


export default __exports__